import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';

import { ReactiveFormsModule } from '@angular/forms';
import { LogueoComponent } from './logueo/logueo.component';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';

import { RecordatorioPwdComponent } from './recordatorio-pwd/recordatorio-pwd.component';
import { AutoFocusModule } from 'primeng/autofocus';
import { InputTextModule } from 'primeng/inputtext';
import { ResourcesModule } from '../resources/resources.module';
import { FloatLabelModule } from 'primeng/floatlabel';


@NgModule({
  declarations: [LogueoComponent, RecordatorioPwdComponent],
  imports: [
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    ButtonModule,
    ToastModule,
    PasswordModule,
    DividerModule,
    ResourcesModule,
    AutoFocusModule,
    InputTextModule,
    FloatLabelModule
  ]
})
export class AuthModule { }
